<template>
  <div>
    <el-dialog :title="$t('system.assign_role')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" class="diglog-card" width="900px" @close="initData">
      <div>

        <div class="assign-role-form">
          <el-form ref="form" :model="form" label-width="150px" :rules="rules" label-position="top">
            <div class="assign-role-container">
              <div class="assign-role-container-left">
                <div class="section-title">{{ $t('system.authority') }}</div>
                <div class="section-tip">{{ $t('tips.following_permission_granted_role') }}</div>
                <SystemMchMenu
                  :menu-list="menuList"
                  :auth-list="checkAuths"
                  :modal-flag="3"
                />
              </div>
              <div class="assign-role-container-right">
                <el-form-item :label="$t('system.role_name')+':'" prop="role_id">
                  <div v-for="role in roleList" :key="role.id" class="role-name-item">
                    <div class="role-name-item-text">
                      {{ role.role_name }}
                    </div>
                    <el-button v-if=" form.role_id === role.id" style="width: 100px" class="filter-btn-add" :disabled="masterAccFlag" @click="handleChangeRole(role)">
                      {{ $t('components.selected') }}
                    </el-button>
                    <el-button v-else style="width: 100px" type="info" :disabled="masterAccFlag" @click="handleChangeRole(role)">
                      {{ $t('components.select') }}
                    </el-button>

                  </div>

                </el-form-item>
                <div />
                <div slot="footer" class="dialog-footer-fixed">
                  <el-button type="primary" plain class="btn-diglog-control" @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
                  <el-button class="btn-diglog-control" type="primary" :disabled="listLoading" @click="submitAssignRole('form')">{{ $t('components.submit') }}</el-button>
                </div>
              </div>
            </div>

          </el-form>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { assignRoleAuthorities, fetchMerchantRoles } from '@/api/system/system'
export default {
  name: 'AssignMchRoleModal',
  components: {
    SystemMchMenu: () => import('../System/SystemBaseMenu')
  },
  props: {
    menuList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      form: {
        mch_user_id: '',
        role_id: ''
      },
      masterAccFlag: true,
      roleList: [],
      checkAuths: [],
      // cities: cityOptions,
      rules: {},
      isIndeterminate: true,
      checkAll: false
    }
  },
  mounted() {
    this.$bus.off('UPDATE_CHECK_AUTH_MODAL')
    this.$bus.on('UPDATE_CHECK_AUTH_MODAL', (value) => {
      this.form.role_auths = value
    })
  },
  methods: {
    getMchRoleList(params = {}) {
      fetchMerchantRoles(params).then(res => {
        this.roleList = res.data
        this.roleList.forEach(item => {
          if (item.id === this.form.role_id) {
            this.checkAuths = item.auth_codes
          }
        })
      })
    },
    handleChangeRole(role) {
      this.form.role_id = role.id
      this.checkAuths = []
      this.roleList.forEach(item => {
        if (item.id === this.form.role_id) {
          this.checkAuths = item.auth_codes
        }
      })
    },
    changeModalStatus(status, row) {
      this.dialogUserVisible = status
      this.form.role_id = row.role_id
      this.form.mch_user_id = row.id
      this.masterAccFlag = row.account_type === 1 && (row.role_id && row.role_id > 0)
      this.getMchRoleList()
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    initData() {
      this.form = {
        role_id: '',
        mch_user_id: ''
      }
      this.checkAuths = []
    },
    submitAssignRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.listLoading = true
            const params = {
              mch_user_id: this.form.mch_user_id,
              role_id: this.form.role_id
            }
            assignRoleAuthorities(params).then(res => {
              this.$message.success('Success')
              this.$emit('updateRoleList')
              this.dialogUserVisible = false
            }).finally(() => {
              this.listLoading = false
            })
          })
        }
      })
    },
    handleCheckAllChange() {

    },
    handleCheckedChange() {

    }
  }
}
</script>

<style scoped>
.assign-role-container ::v-deep .el-checkbox__input.is-disabled+span.el-checkbox__label{
  color: #488CE8;
}

.assign-role-container  ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #488CE8;
  border-color: #488CE8;
}
.assign-role-container  ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  border-color: #FFF;
}

.assign-role-container{
  width: 100%;
  display: flex;
}
.assign-role-container-left{
  position: relative;
  margin: -24px;
  padding: 24px;
  width: 350px;
  margin-right: 24px;
  background: rgba(72, 140, 232, 0.10);
  opacity: 0.5;

}
.assign-role-container-right{
  flex: 1;
  position: relative;
}
.role-name-item{
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.role-name-item-text{
  color: #364250;
  font-size: 14px;
  font-weight: bold;
}

.dialog-footer-fixed{
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
